import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BtnGoBack } from '../Components';
import { useForm } from '../../Hooks/useForm';
import { AuthContext } from '../../Auth';
import { jwtDecode } from 'jwt-decode';
import { requestGet } from '../../Helpers';
import { CardAddress } from '../../Profile/Address/Components/CardAddress';

export const PersonalInformation = () => {

    const {formState, onInputChange} = useForm({
    });

    const { user } = useContext(AuthContext);

    const [myCards, setMyCards] = useState([]);
  
    const navigate = useNavigate();
  
    useEffect(() => {
      try {
        const decode = jwtDecode(user.token);
  
        handleGetCards(decode?.user_id);
      } catch (error) {
        console.log(error);
      }
    }, [user]);
  
    const handleGetCards = (user) => {
      requestGet(`shipping_addresses/?user=${user}`)
        .then((data) => {
          setMyCards(data ?? []);
        })
        .catch((error) => {
          console.log(error);
          setMyCards([]);
        });
    };
  

    const handleContinue = () => {
        navigate('/payment/purchase-detail');
    }
  
    return (
        <div className='container mt-3'>
            <div className='row justify-content-center'>
                <div className='container'>
                    <div className='card' style={{ boxShadow: 'none' }}>

                        <div className='row'>
                        {
                            myCards?.results?.map((item) => {
                                return (
                                    <div className='col'>
                                        <div className="form-check" key={item.id}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="flexRadioDefault1"
                                            />
                                            <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                <CardAddress
                                                    key={item.id}
                                                    name={item.name}
                                                    address={item.address}
                                                    city={item.city}
                                                    state={item.state}
                                                    zipcode={item.zipcode}
                                                    phone={item.phone}
                                                    updated_at={item.updated_at}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        </div>

                        <div className='d-flex justify-content-end'>
                            <BtnGoBack />
                            &nbsp;
                            <button className="btn btn-primary">Guardar</button>
                            &nbsp;                           
                            <button className='btn btn-primary' onClick={handleContinue}>Continuar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
